import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from "react";

interface ApiContextProps {
  isUnauthorized: boolean;
  handleUnauthorized: () => void;
  setIsUnauthorized: any;
  menuData: any;
  setMenuData: any;
  showSidebar: any;
  setShowSidebar: any;
}

const ApiContext = createContext<ApiContextProps | undefined>(undefined);

export const useApi = (): ApiContextProps => {
  const context = useContext(ApiContext);
  if (!context) {
    throw new Error("useApi deve ser usado dentro de um ApiProvider");
  }
  return context;
};

interface ApiProviderProps {
  children: ReactNode;
}

export const ApiProvider: React.FC<ApiProviderProps> = ({ children }) => {
  const [isUnauthorized, setIsUnauthorized] = useState(false);
  const [menuData, setMenuData] = useState(null);
  const [showSidebar, setShowSidebar] = useState(false);

  useEffect(() => {
    // console.log("Menu Data", menuData)
    if (menuData != null) {
      setShowSidebar(true);
    } else {
      setShowSidebar(false);
    }
  }, [menuData]);

  const handleUnauthorized = () => {
    setIsUnauthorized(true);
    if (
      window.location.pathname != "/signin" &&
      window.location.pathname != "/code" &&
      window.location.pathname != "/signup" &&
      !window.location.pathname.startsWith("/authenticate")
    ) {
      localStorage.removeItem("menu");
      window.location.href = "/code";
    }
  };

  const contextValue: ApiContextProps = {
    isUnauthorized,
    handleUnauthorized,
    setIsUnauthorized,
    menuData,
    setMenuData,
    showSidebar,
    setShowSidebar,
  };

  return (
    <ApiContext.Provider value={contextValue}>{children}</ApiContext.Provider>
  );
};
